export default {
  nav: {
    protocol: '协议',
    technology: '技术',
    ecosystem: '生态系统',
    developers: '开发者',
    community: '社区',
    home: '首页'
  },
  search: {
    placeholder: '搜索'
  },
  hero: {
    title: '为Web3构建隐私保护基石',
    subtitle: '通过零知识证明和同态加密技术，让数据在可验证的前提下安全共享，实现真正的数据主权',
    announcement: '主网即将上线 · 加入测试网',
    join: {
      testnet: '加入测试网'
    },
    cta: {
      build: '开始构建',
      learn: '了解更多'
    }
  },
  feature: {
    zkproof: {
      title: '零知识证明',
      desc: '在不泄露信息的情况下证明数据真实性'
    },
    homomorphic: {
      title: '同态加密',
      desc: '对加密数据直接进行计算操作'
    },
    sovereignty: {
      title: '数据主权',
      desc: '用户完全控制自己的数据和身份'
    },
    crosschain: {
      title: '跨链互操作',
      desc: '与主流公链无缝集成和交互'
    }
  },
  home: {
    coreProblem: '核心问题',
    problemTitle: '当前区块链面临的挑战',
    problemDescription: '公开透明的区块链导致用户数据和交易隐私泄露,用户失去了对自身数据的控制权,无法将数据价值变现',
    privacyLeakage: {
      title: '隐私泄露',
      description: '区块链的公开透明特性导致所有交易和数据都暴露在公众视野中,用户的财务状况、交易习惯等隐私信息完全暴露。',
      items: ['交易金额和地址公开', '用户行为模式可追踪', '商业机密无法保护']
    },
    dataOutOfControl: {
      title: '数据失控',
      description: '用户失去了对自身数据的控制权,无法决定数据的使用方式,也无法从数据价值中获得收益。',
      items: ['数据被平台垄断', '无法控制数据使用', '数据价值无法变现']
    },
    techArchitecture: '技术架构',
    techLayersTitle: '四大技术层级',
    techLayersDescription: '构建完整的隐私保护技术栈',
    techLayers: {
      privacyLayer: {
        title: '🧠 隐私保护层',
        description: '使用零知识证明和同态加密技术，确保数据在计算和验证过程中保持机密，实现"数据可验证而不可见"。'
      },
      identityLayer: {
        title: '🔐 数据身份层',
        description: '基于去中心化身份，让用户自主管理其身份信息和数据授权，拥有完整的数字主权。'
      },
      economyLayer: {
        title: '⚙️ 智能经济层',
        description: '通过隐私保护的智能合约，构建一个去中心化的数据交易市场，让数据价值安全、公平地流动。'
      },
      interopLayer: {
        title: '🌐 互联层',
        description: '实现与Ethereum、BSC、Solana等主流公链的跨链兼容，将隐私保护能力扩展到整个多链生态。'
      }
    },
    applications: {
      title: '应用场景',
      subtitle: '隐私保护的全新应用',
      privacyDefi: {
        title: '隐私保护DeFi',
        description: '在保护用户隐私的前提下，提供去中心化金融服务，防止交易信息泄露。',
        button: '了解更多'
      },
      dataMarketplace: {
        title: '数据市场',
        description: '构建安全的数据交易市场，让数据提供者在不暴露原始数据的情况下获得收益。',
        button: '了解更多'
      },
      identityVerification: {
        title: '身份验证',
        description: '提供去中心化的身份验证服务，用户可以证明身份而不泄露个人信息。',
        button: '了解更多'
      },
      supplyChainPrivacy: {
        title: '供应链隐私',
        description: '在供应链管理中保护商业机密，同时确保数据的可验证性和透明度。',
        button: '了解更多'
      }
    },
    networkActivity: {
      title: '网络活动',
      subtitle: '隐私保护生态系统',
      description: 'Titron网络上的所有活动',
      stats: {
        transactions: {
          value: '1000万+',
          description: '已处理的隐私保护交易数量'
        },
        dataValue: {
          value: 'US$50亿',
          description: '通过协议流转的数据价值'
        },
        successRate: {
          value: '99.9%',
          description: '隐私保护成功率'
        },
        networks: {
          value: '15+',
          description: '支持的区块链网络数量'
        }
      },
      buttons: {
        developerEcosystem: '开发者生态',
        networkStats: '网络统计'
      }
    },
    valueComparison: {
      title: '价值观对比',
      subtitle: 'Web3正在经历变革',
      description: '从数据垄断到数据主权',
      traditionalMode: '传统模式',
      titronValues: ['数据主权', '隐私保护', '可验证计算', '去中心化', '跨链互操作', '零知识证明', '用户控制'],
      traditionalValues: ['数据垄断', '隐私泄露', '黑盒计算', '中心化', '孤立系统', '完全透明', '平台控制']
    },
    learning: {
      title: '学习',
      subtitle: '了解隐私保护技术',
      description: '隐私保护技术可能令你觉得复杂。不用担心，这些材料可让你在几分钟内了解Titron的核心概念。',
      hotTopics: '热门话题',
      topics: {
        zkProof: '什么是零知识证明？',
        dataPrivacy: '如何保护数据隐私？',
        dataSovereignty: '数据主权入门指南',
        whitepaper: 'Titron白皮书'
      },
      moreResources: '更多学习资源'
    },
    developers: {
      title: '开发者',
      subtitle: '隐私保护开发者社区',
      description: 'Titron是Web3隐私保护领域最活跃的开发者生态系统。使用我们的SDK和工具，轻松构建隐私保护应用程序。',
      buttons: {
        documentation: '开发者文档',
        sdkDownload: 'SDK下载'
      },
      codeExamples: '代码示例',
      examples: {
        voting: {
          title: '隐私保护投票',
          description: '构建匿名投票系统'
        },
        identity: {
          title: '零知识身份验证',
          description: '验证身份而不泄露信息'
        },
        transactions: {
          title: '加密数据交易',
          description: '安全的数据市场交易'
        }
      }
    },
    community: {
      title: 'TITRON 社区',
      subtitle: '由社区构建',
      description1: 'Titron由全球隐私保护技术爱好者、开发者、研究者和用户共同构建，致力于推动Web3隐私保护技术的发展。',
      description2: '欢迎加入我们的社区，与世界各地的隐私保护技术专家交流，参与协议开发，共同构建更加私密和安全的Web3未来。',
      description3: 'Titron社区是学习隐私保护技术和参与Web3隐私革命的最佳起点。',
      buttons: {
        aboutTitron: '关于Titron',
        discord: 'Discord',
        github: 'GitHub'
      }
    },
    joinTitron: {
      title: '加入 Titron',
      subtitle: '参与构建Web3隐私保护的未来，让数据主权回归用户',
      contributions: {
        developer: {
          title: '开发者贡献',
          description: '参与协议开发，构建隐私保护工具和应用程序。'
        },
        github: {
          title: 'GitHub',
          description: '查看源代码，提交问题和改进建议'
        },
        discord: {
          title: 'Discord',
          description: '加入社区讨论，获取技术支持和最新动态。'
        },
        research: {
          title: '研究合作',
          description: '参与隐私保护技术研究，推动学术发展。'
        }
      }
    }
  },
  common: {
    learnMore: '了解更多'
  },
  language: {
    zh: '简体中文',
    en: 'English'
  },
  footer: {
    protocol: '协议',
    whitepaper: '白皮书',
    roadmap: '路线图',
    governance: '治理',
    developers: '开发者',
    docs: '文档',
    sdk: 'SDK',
    api: 'API',
    community: '社区',
    discord: 'Discord',
    github: 'GitHub',
    twitter: 'Twitter',
    company: '公司',
    about: '关于我们',
    careers: '加入我们',
    contact: '联系我们',
    newsletter: {
      title: '订阅我们的新闻',
      description: '获取最新的协议更新和技术动态',
      placeholder: '输入您的邮箱',
      subscribe: '订阅'
    },
    copyright: '© 2020-2025 Titron. All rights reserved.',
    privacy: '隐私政策',
    terms: '服务条款'
  },
  technology: {
    title: 'Titron 技术栈',
    subtitle: '基于先进的密码学技术和创新的共识机制，构建下一代隐私保护区块链基础设施',
    coreTech: '核心技术',
    consensus: '共识机制',
    specs: '技术规格',
    innovation: '创新亮点'
  },
  ecosystem: {
    title: 'Titron 生态系统',
    subtitle: '构建多元化的隐私保护应用生态，涵盖DeFi、隐私计算、数字身份和数据市场等领域',
    overview: '生态概览',
    categories: '生态分类',
    partnerships: '战略合作',
    upcoming: '即将上线'
  },
  developers: {
    title: 'Titron 开发者',
    subtitle: '使用强大的开发工具和丰富的资源，构建下一代隐私保护应用程序',
    community: '开发者社区',
    tools: '开发工具',
    quickStart: '快速开始',
    examples: '代码示例',
    resources: '开发资源'
  },
  community: {
    title: 'Titron 社区',
    subtitle: '加入全球最大的隐私保护技术社区，与志同道合的开发者、研究者和用户一起构建Web3的未来',
    overview: '社区概览',
    channels: '社区频道',
    events: '社区活动',
    governance: '治理结构',
    spotlight: '社区亮点'
  }
};
